import React, { Component } from 'react';
import DepenseMensuelGrid from '../components/DepenseMensuelGrid';


class  DepenseMensuelle extends Component  {


  render() {
 
  
        return ( 
            
            <section className="services-section-four">

                <div className='auto-container'>
                  
                        
                        <DepenseMensuelGrid />
                   


                </div>

            </section>
        )
    }
  }

export default DepenseMensuelle 

